<template>
        <div class="box">
          <router-link style="text-decoration:none" class="register-imgs" to="/registerChoice">
            <img src="../../assets/register1.png" alt />
            <img src="../../assets/register2.png" alt />
          </router-link>
          <h1>登录</h1>
          <div v-if="scanningBoo==0" style="height: 60%;">
            <img @click="createdQrcode" :src="src" alt class="qr-code" />
          </div>
          <div class="qr-code-yes"  v-if="scanningBoo==1||scanningBoo==2">
            <div>
              <i class="el-icon-circle-check"></i>
            </div>
            <h2>扫描成功</h2>
            <p>请勿刷新本页面,按手机提示操作！</p>
          </div>
          <div class="qr-code-yes qr-code-off"  v-if="scanningBoo==3">
            <div>
              <i class="el-icon-warning-outline"></i>
            </div>
            <h2>二维码已失效</h2>
            <el-button  type="danger" class="btn" @click="createdQrcode">刷新</el-button>
          </div>
          <p v-if="scanningBoo==0">使用手机微信扫码登录</p>
        </div>
</template>
<script>
export default {
  data() {
    return {
      scanningBoo:3,
      src:"",
    };
  },
  created() {
    sessionStorage.removeItem('token');
  },
  mounted() {
    this.createdQrcode();
  },
  methods: {
    // 监听扫码动作
    listenQRcode() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        axios
          .get(`/msys/CustomerWeb/GetLoginOrCodeState?no=${this.codeNo}`)
          .then(res => {
            //state 0未扫码 1 已扫码等待操作 2操作成功 3超时
            this.scanningBoo=res.data.state
            if (res.isSuccess && res.data.state==2) {
              clearInterval(this.timer);
              //跳转到指定连接
               window.location.href=res.data.url
            }
            if (res.isSuccess && res.data.state==3) {
              clearInterval(this.timer);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }, 2000);
    },
    createdQrcode() {
      this.scanningBoo=0
      axios
        .get(`/msys/CustomerWeb/GetLoginOrCodeNo`)
        .then(res => {
          console.log(res);
          this.codeNo = res.data.no;
          this.src =this.$config.$baseUrl+"/msys/CustomerWeb/LoginQrCode?no=" + res.data.no;
          // 开启轮询
          this.listenQRcode();
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,.9);
  padding: 6.6% 0 8.8%;
  text-align: center;
  box-sizing: border-box;
  .register-imgs {
    position: absolute;
    right: 5.2%;
    top: 4.44%;
  }
  h1 {
    font-size: 22px;
    color: #000026;
    font-weight: normal;
  }
  .qr-code {
    position: relative;
    display: inline-block;
    height: 100%;
    width: auto;
    cursor: pointer;
  }
  .qr-code-yes {
    text-align: center;
    i {
      margin: 40px 0 30px;
      font-size: 100px;
      color: rgb(56, 126, 255);
    }
    p {
      font-size: 16px;
    }
  }
  .qr-code-off{
    i {
      color: gray;
    }
    h2{
      color: gray;
    }
    .btn{
      margin-top: 20px;
      background: red;
      color: #ffffff;
      padding: 15px 50px;
    }
  }
  p {
    font-size: 18px;
    color: #000026;
    font-weight: normal;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue